//@flow
import * as React from 'react';
import createBridge from './bridge';

type Props = {
  publicKey: string,
  src: string
};

export const PaymentBridge: React.FC<props> = props => {
  let paylike = null;

  React.useEffect(() => {
    (async function() {
      const Paylike = await createBridge({
        src: props.src,
        async: false,
        ready: () => window.Paylike
      });
      paylike = Paylike(props.publicKey);
    })();
  });

  function pay(opts) {
    const {
      locale = 'da',
      title,
      description,
      currency,
      amount,
      product,
      custom
    } = opts;
    const payload = {
      locale,
      title,
      description,
      currency,
      amount,
      descriptor: `Akutbolig.dk${
        custom.dwelling ? `*${custom.dwelling.substr(0, 8)}` : ''
      }`,
      custom: { ...custom, product }
    };

    return new Promise((rs, rj) => {
      paylike.popup(payload, async (err, res) => {
        if (err) {
          if (__DEV__) {
            console.log(err);
          }
          return rj(err);
        }
        return rs(res.transaction.id);
      });
    });
  }
  return props.children(pay);
};
